import React from "react";
import "./App.scss";
import MainRouter from "./_routers/Router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {

  return (
    <>
      <ToastContainer />
      <MainRouter />
    </>
  );
}

export default App;
